import React from 'react';
import { getUILoc } from '../../utils/cardUtils.js';

const CreditsOverlay = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const credits = {
    title: getUILoc('CREDITS.TITLE'),
    intro: getUILoc('CREDITS.INTRO'),
    coding: getUILoc('CREDITS.CODING'),
    note: getUILoc('CREDITS.NOTE'),
    aa: getUILoc('CREDITS.AA'),
    illustration: getUILoc('CREDITS.ILLUSTRATION'),
    sound: getUILoc('CREDITS.SOUND'),
    outro: getUILoc('CREDITS.OUTRO')
  };

  return (
    <div className="overlay" onClick={handleOverlayClick}>
      <div className="overlay-modal credits-overlay">
        <div className="overlay-header">
          <h2>{credits.title}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="overlay-content">
          <div className="credits-content-structured">
            <p className="credits-intro">{credits.intro}</p>
            
            <section className="credits-section">
              <pre className="credits-subtext">{credits.coding}</pre>
              <p className="credits-note">{credits.note}</p>
            </section>

            <section className="credits-section">
              <pre className="credits-subtext">{credits.aa}</pre>
            </section>

            <section className="credits-section">
              <pre className="credits-subtext">{credits.illustration}</pre>
            </section>

            <section className="credits-section">
              <pre className="credits-subtext">{credits.sound}</pre>
            </section>

            <p className="credits-outro">{credits.outro}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditsOverlay;